import { useNavigate } from "@tanstack/react-router"
import { getRefreshToken } from "./refreshTokenStorage"
import { useLogoutMutation } from "./api"
import { clearAuth } from "./slice"
import { useDispatch } from "@/base/store"
import baseApi from "@/base/baseApi"

export default () => {
  const [logout] = useLogoutMutation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  return async () => {
    await navigate({ to: "/" }) // Avoids storing redirectUrl
    const refreshToken = getRefreshToken()
    if (refreshToken) {
      await logout(refreshToken)
    }
    dispatch(clearAuth())
    dispatch(baseApi.util.resetApiState())
  }
}
